module.exports = __webpack_public_path__ + "static/image/service/m/ceo@3x.jpg?4b5f34bc";